import { Injectable } from '@angular/core';
import { CrudBaseService } from '../crud.service';
import { Gateway } from '../models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class GatewayService extends CrudBaseService<Gateway> {
    constructor(httpClient: HttpClient) {
        super('/payment_gateway', httpClient);
    }

    list(): Observable<Gateway[]> {
        return this.httpClient
            .get<Gateway[]>(`${this.basePath}`)
            .pipe(map((res: any) => res && res.data));
    }
}
